import request from '@/utils/request';

export default {
  /**
   * 后台验证登录信息
   * @param username 用户名（邮箱）
   * @param password 用户密码
   * @return {*}
   */
  verifyLogin(username, password) {
    return request.post('user/login', {
      username,
      password,
    });
  },
  /**
   * 校验Session是否有效
   * @return {true表示Session有效，false表示无效}
   */
  checkSession() {
    return request.get('user/session');
  },
  logout() {
    return request.post('user/logout');
  },
};



// WEBPACK FOOTER //
// ./src/api/user.js